<template>
  <div class="ownershipManage-container">
    <!-- 搜索 -->
    <el-row>
      <el-form
        inline
        size="medium"
        :model="queryForm"
        ref="queryForm"
        class="input-form-inline"
        @submit.native.prevent
      >
        <el-form-item class="r-20" prop="name">
          <el-input
            v-model.trim="queryForm.name"
            placeholder="请输入产权方名称"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="headName">
          <el-input
            v-model.trim="queryForm.headName"
            placeholder="请输入负责人姓名"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="areaIds" style="margin-right: 40px">
          <el-cascader
            v-model="queryForm.areaIds"
            style="width: 270px"
            size="mini"
            placeholder="请选择省市区"
            ref="cascader"
            :options="areaData"
            :props="{
              emitPath: true,
              multiple: true,
              checkStrictly: false,
              value: 'id',
              children: 'areaDTOList',
              label: 'name',
            }"
            clearable
            collapse-tags
          >
          </el-cascader>
        </el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="resetForm">取消</el-button>
      </el-form>
    </el-row>
    <!-- 新增 -->
    <el-row>
      <el-button type="primary" @click="add">新增</el-button>
    </el-row>
    <!-- 表格 -->
    <el-row style="margin-top:20px !important">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        height="600px"
        stripe
      >
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          label="产权方名称"
          prop="name"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="省"
          prop="dprovinceName"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="市"
          prop="dcityName"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="区/县"
          prop="dareaName"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="详细住址"
          prop="address"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="负责人信息" min-width="200">
          <template slot-scope="{ row }">
            <div v-for="item in row.headList" :key="item.id">
              <span>{{ item.headName }}</span>
              <span>-</span>
              <span>{{ item.headPhone }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click.stop="editor(row)"
              style="margin-left: 10px"
              >修改</el-button
            >
            <el-button type="text" @click.stop="delData(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination
        class="ownership-pagination"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="ownershipDialog"
    >
      <el-form
        size="mini"
        inline
        :model="ownershipForm"
        ref="addForm"
        :rules="ownershipRules"
        label-width="140px"
        class="mini-dialog"
        @submit.native.prevent
      >
        <el-form-item label="产权方名称" prop="name">
          <el-input
            v-model.trim="ownershipForm.name"
            autocomplete="off"
            placeholder="请输入产权方名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="产权方地址" class="select-list">
          <el-row>
            <el-col :span="8">
              <el-form-item prop="dprovinceId">
                <el-select
                  v-model="ownershipForm.dprovinceId"
                  placeholder="省"
                  class="select-item"
                  @visible-change="handleProvinceChange"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="dcityId">
                <el-select
                  v-model="ownershipForm.dcityId"
                  placeholder="市"
                  class="select-item"
                  @visible-change="handleCityChange"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="dareaId">
                <el-select
                  v-model="ownershipForm.dareaId"
                  placeholder="区/县"
                  class="select-item"
                  @visible-change="handleDareaChange"
                >
                  <el-option
                    v-for="item in districtList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item prop="address" style="margin-bottom:0">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入详细地址"
                v-model.trim="ownershipForm.address"
              >
              </el-input>
            </el-form-item>
          </el-row>
        </el-form-item>
        <user-master-item
          v-for="(item, index) in ownershipForm.headList"
          :key="item.id"
          :userMasterListItem="item"
          :itemHeadNameProps="'headName' + index"
          :itemHeadPhoneProps="'headPhone' + index"
          @closeAdd="closeAdd"
        ></user-master-item>
      </el-form>
      <div class="add-master">
        <el-button
          v-show="ownershipForm.headList.length < 10"
          type="text"
          icon="el-icon-plus"
          @click="addMaster"
          >增加管理人</el-button
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserMasterItem from "./UserMasterItem.vue";
var nanoid = require("nanoid");
export default {
  name: "OwnershipManage",
  components: {
    UserMasterItem,
  },
  data() {
    return {
      queryForm: {
        name: "",
        headName: "",
        areaIds: [],
      },
      defaultHeadList: {
        uid: 1,
        name: "管理人1",
        nameMsg: "请输入管理人员1",
        phone: "管理人1手机号",
        phoneMsg: "请输入管理人员1手机号",
        headName: "",
        headPhone: "",
      },
      editTag: 0,
      provinceList: [],
      cityAllList: [],
      cityList: [],
      districtList: [],
      areaTreeData: [],
      tableData: [],
      ownershipForm: {
        id: 0,
        name: "",
        dprovinceId: null,
        dcityId: null,
        dareaId: null,
        dprovinceName: "",
        dcityName: "",
        dareaName: "",
        address: "",
        headName: "",
        headPhone: "",
        headList: [],
      },
      ownershipRules: {
        name: {
          required: true,
          message: "请输入产权方名称",
          trigger: "change",
        },
        dprovinceId: [
          {
            required: true,
            message: "请选择省份",
            trigger: "change",
          },
        ],
        dcityId: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        dareaId: [
          {
            required: true,
            message: "请选择区域",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "change",
          },
        ],
      },
      dialogVisible: false,
      addVisible: false,
      dialogTitle: "",
      currentPage: 1,
      limit: 10,
      total: 0,
      areaData: [],
      userMasterLimit: 10,
      editorId: null,
    };
  },
  created() {
    this.getAreaList();
    this.getTableData();
    this.getProvince();
  },
  methods: {
    handleExpandChange(row, open) {
      // 这里可以执行你需要的操作
      if (open) {
        row.disabled = true;
      } else {
        row.disabled = false;
      }
    },
    async closeAdd({ id, uid }) {
      // console.log("测试监听子组件方法", id);
      // 替换删除的元素项为空，方便后续添加
      if (!id) {
        let newHeadList = this.ownershipForm.headList.map((item) => {
          return item.uid == uid ? "" : item;
        });
        // 如果需要更新原数组，可以进行赋值操作（根据实际需求决定是否替换原数组）
        this.ownershipForm.headList = newHeadList;
        return;
      }
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 删除接口
          let { data: res } = await this.$axios.get(
            "/api/property/management/delete/warden?id=" + id
          );
          if (res.code == 1) {
            this.$message({ type: "success", message: "删除成功!" });
            // 刷新修改弹框数据
            this.getEditorMasterData(this.editorId);
            // // 关闭弹框
            // this.dialogVisible = false;
            // // 刷新表格数据
            // this.getTableData();
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addMaster() {
      let obj = {};
      // 得到删除元素的索引
      let index = this.ownershipForm.headList.findIndex((item) => item == "");
      // 判断是否有删除的元素
      if (index == -1) {
        obj = {
          uid: nanoid(), // 新增删除对应的管理人使用
          name: "管理人" + (this.ownershipForm.headList.length + 1),
          nameMsg: "管理人员" + (this.ownershipForm.headList.length + 1),
          phone: "管理人" + (this.ownershipForm.headList.length + 1) + "手机号",
          phoneMsg:
            "请输入管理人员" +
            (this.ownershipForm.headList.length + 1) +
            "手机号",
          headName: "",
          headPhone: "",
        };
        this.ownershipForm.headList.push(obj);
      } else {
        // 有删除的元素就替换空元素
        obj = {
          uid: nanoid(), // 新增删除对应的管理人使用
          name: "管理人" + (index + 1),
          nameMsg: "管理人员" + (index + 1),
          phone: "管理人" + (index + 1) + "手机号",
          phoneMsg: "请输入管理人员" + (index + 1) + "手机号",
          headName: "",
          headPhone: "",
        };
        this.ownershipForm.headList.splice(index, 1, obj);
      }
    },
    query() {
      this.getTableData();
    },
    resetForm() {
      this.$resetForm(this, "queryForm");
      Object.assign(this.ownershipForm, this.$options.data().ownershipForm);
      this.getTableData();
    },
    reset() {
      this.dialogVisible = false;
      // 移除校验效果
      this.$refs.addForm.clearValidate();
      this.getTableData();
    },
    // 修改操作
    editor(row) {
      this.editorId = row.id;
      //清空表单数据【？？？清除表单数据，不会闪现出取消修改的内容】
      this.$resetForm(this, "queryForm");
      this.$resetForm(this, "addForm");
      // 修改
      if (this.editTag !== 0) {
        this.editTag = 0;
      }
      this.editTag = 1;
      this.dialogTitle = "修改产权方信息";
      this.getProvince();
      this.getCity(row.dprovinceId);
      this.getDistrict(row.dcityId);
      // 获取修改弹框的管理人数据
      this.getEditorMasterData(row.id).then(() => {
        this.dialogVisible = true;
      });
    },
    async getEditorMasterData(id) {
      let { data: res } = await this.$axios.get(
        "/api/property/management/queryDetails?id=" + id
      );
      if (res.code == 1) {
        this.ownershipForm = res.data;
        if (this.ownershipForm.headList.length == 0) {
          this.ownershipForm.headList[0] = this.defaultHeadList;
        } else {
          this.ownershipForm.headList.forEach((item, index) => {
            if (index == 0) {
              item.uid = 1;
            } else {
              item.uid = nanoid();
            }
            item.id = res.data.headList[index].id;
            item.headName = res.data.headList[index].headName;
            item.headPhone = res.data.headList[index].headPhone;
            item.name = "管理人" + (index + 1);
            item.phone = "管理人" + (index + 1) + "手机号";
            item.index = index;
          });
        }
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 新增
    add() {
      //清空表单数据
      this.$resetForm(this, "queryForm");
      this.$resetForm(this, "addForm");
      this.ownershipForm = this.$options.data().ownershipForm;
      this.defaultHeadList = this.$options.data().defaultHeadList;
      this.ownershipForm.headList[0] = this.defaultHeadList;
      if (this.editTag !== 0) {
        this.editTag = 0;
      }
      this.editTag = 2;
      this.dialogTitle = "新增产权方信息";
      this.dialogVisible = true;
    },
    async delData(row) {
      //多选删除
      if (!row.id) {
        return;
      }
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.get(
          "/api/property/management/delete?id=" + row.id
        );
        if (res.code == 1) {
          this.$message.success("操作成功");
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          this.getTableData();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    saveOrUpdate() {
      let data = [];
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          // 新增
          if (this.editTag == 2) {
            data = await this.$axios.post(
              "/api/property/management/save",
              this.ownershipForm
            );
          }
          // 修改
          if (this.editTag == 1) {
            data = await this.$axios.post(
              "/api/property/management/update",
              this.ownershipForm
            );
          }
          let res = data.data;
          if (res.code == 1) {
            //信息提示
            this.$message.success("操作成功");
            this.dialogVisible = false;
            //刷新表格【？？？在关闭弹框之前刷新表格数据会触发第二次form表单校验】
            this.getTableData();
          } else {
            this.$message.warning(res.msg);
          }
        }
      });
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    async getProvince() {
      let { data: res } = await this.$axios.get(
        "/api/property/management/dProvinceList"
      );
      if (res.code == 1) {
        this.provinceList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 获取市区数据
    async getCity(provinceId) {
      // 选中省时得到省的id，使用该id匹配市
      let { data: res } = await this.$axios.get(
        "/api/property/management/dCityList",
        {
          params: { id: provinceId },
        }
      );
      if (res.code == 1) {
        this.cityList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 获取区/县数据
    async getDistrict(cityId) {
      // 选中省时得到省的id，使用该id匹配市
      let { data: res } = await this.$axios.get(
        "/api/property/management/dAreaList",
        {
          params: { id: cityId },
        }
      );
      if (res.code == 1) {
        this.districtList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 获取省
    handleProvinceChange(val) {
      if (val) {
        if (this.ownershipForm.dcityId || this.ownershipForm.dareaId) {
          this.ownershipForm.dcityId = "";
          this.ownershipForm.dareaId = "";
        }
      }
    },
    // 打开市，获取市数据
    handleCityChange(val) {
      if (val) {
        if (this.ownershipForm.districtId) {
          this.ownershipForm.districtId = "";
        }
        this.getCity(this.ownershipForm.dprovinceId);
      }
    },
    // 打开区
    handleDareaChange(val) {
      if (val) {
        this.getDistrict(this.ownershipForm.dcityId);
      }
    },
    async getAreaList() {
      let { data: res } = await this.$axios.get(
        "/api/property/management/addressList"
      );
      if (res.code == 1) {
        this.areaData = res.data;
        // 处理省市区数据
        this.handleAddress(res.data);
        this.areaIds = res.data[0].id;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleAddress(data) {
      data.forEach((item) => {
        if (item.areaDTOList.length == 0) {
          item.areaDTOList = undefined;
        } else {
          this.handleAddress(item.areaDTOList);
        }
      });
      return data;
    },
    async getTableData() {
      let obj = {};
      if (this.queryForm.areaIds.length > 0) {
        let dprovinceId = [];
        let dcityId = [];
        let dareaId = [];
        this.queryForm.areaIds.forEach((item) => {
          dprovinceId.push(item[0]);
          dcityId.push(item[1]);
          dareaId.push(item[2]);
        });
        obj.dprovinceId = Array.from(new Set(dprovinceId));
        obj.dcityId = Array.from(new Set(dcityId));
        obj.dareaId = Array.from(new Set(dareaId));
      }
      obj.headName = this.queryForm.headName;
      obj.name = this.queryForm.name;
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.post(
        "/api/property/management/pageList",
        obj
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ownershipManage-container {
  height: calc(100% - 40px);
  margin: 20px;
  padding: 0 20px;
  background: #fff;
  box-sizing: border-box;
  /* 更改文本框的placeholder的颜色 */
  input::input-placeholder {
    color: #bbb;
    font-size: 14px;
  }
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #bbb;
    font-family: Microsoft YaHei;
    font-size: 14px;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #bbb;
    font-size: 14px;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19  */
    color: #bbb;
    font-size: 14px;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10  */
    color: #bbb;
    font-size: 14px;
  }
  .ownershipDialog /deep/ .el-form-item__content {
    height: auto !important;
  }
  // 模态框样式设置
  ::v-deep .el-dialog {
    width: 40%;
    min-width: 672px;
    .el-dialog__body {
      max-height: 620px;
      .el-form {
        max-height: 600px;
        overflow-y: auto;
      }
    }
  }
  ::v-deep .el-textarea__inner {
    font-family: "Microsoft YaHei";
  }
  ::v-deep .el-cascader__tags {
    width: 64%;
    flex-wrap: nowrap;
  }
  .ownership-pagination {
    margin-top: 10px;
  }
  .select-list {
    /deep/ .el-form-item__label:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
</style>
